import type { PropsWithChildren } from 'react'
import { useEffect } from 'react'

import { type RouteComponentProps, withRouter } from 'react-router'

const ScrollToTopBase = (props: PropsWithChildren<RouteComponentProps>) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [props.location.pathname])

  return <>{props.children}</>
}

export const ScrollToTop = withRouter(ScrollToTopBase)
